module.exports = __webpack_public_path__ + "img/db.0c499f1c.svg";